<template>
  <div
    class="credit-card"
  >
    <h2 class="credit-card__title">Credit Card</h2>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="{ 'input-error': cardholderNameError }"
    >
      <div class="stripe-card__number-row">
        <input
          class="cardknox-ach-fields"
          placeholder="Cardholder Name"
          v-model="cardholderName"
        />
      </div>
    </div>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="{ 'input-error': hasCardError }"
    >
      <div class="stripe-card__number-row">
        <div
          :id="'card-number-' + stripeItemID"
          class="stripe-card__number"
        />
      </div>
      <div
        class="stripe-card__row-right-col"
      >
        <div
          :id="'card-expiry-' + stripeItemID"
          class="stripe-card__date"
        />
        <div
          :id="'card-cvc-' + stripeItemID"
          class="stripe-card__cvc"
        />
      </div>
    </div>
    <div
      :id="'payment-message-' + stripeItemID"
      v-if="hasCardError"
      class="form__error credit-card__error"
    >
      <div v-if="cardNumberError">
        {{ cardNumberError }}
      </div>
      <div v-if="cardCvcError">
        {{ cardCvcError }}
      </div>
      <div v-if="cardExpiryError">
        {{ cardExpiryError }}
      </div>
    </div>
    <div
      :id="'card-error-' + stripeItemID"
      class="form__error credit-card__error"
    />
  </div>
</template>

<script>


import store from "@/store";

export default {
  props: {
    stripeItemID: {
      type: String,
      default: '',
    },
    hasCardError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    cardholderName: {
      get: function () {
        return this.$store.getters['formValidation/getCreditCardField']('cardholder_name')
      },
      set: function (val) {
        store.commit('formValidation/setCreditCardFormData', {
          field: 'cardholder_name',
          value: val,
        })
      }
    },
    cardholderNameError() {
      return this.$store.getters['formValidation/getCreditCardError']('cardholder_name')
    },
    cardNumberError() {
      return this.$store.getters['formValidation/getCreditCardError']('card_number')
    },
    cardExpiryError() {
      return this.$store.getters['formValidation/getCreditCardError']('card_expiry')
    },
    cardCvcError() {
      return this.$store.getters['formValidation/getCreditCardError']('card_cvc')
    },
  },
}
</script>

<style lang="scss">

</style>
